import { lazy } from "react";

export const EstateManagersSetup = lazy(
  () => import("./EstateManagersSetup/EstateManagersSetup"),
);

export const EstateManagersSetupOtp = lazy(
  () =>
    import("./EstateManagersSetup/EstateManagersSetupOtp/EstateManagersSetupOtp"),
);

export const EstateManagersDashboard = lazy(
  () => import("./EstateManagersDashboard/EstateManagersDashboard"),
);

export const EstateProjectManagement = lazy(
  () => import("./EstateProjectManagement/EstateProjectManagement"),
);

export const EstateProjectDetails = lazy(
  () =>
    import("./EstateProjectManagement/EstateProjectDetails/EstateProjectDetails"),
);

export const EstateOrderManagement = lazy(
  () => import("./EstateOrderManagement/EstateOrderManagement"),
);

export const EstateInvestorManagement = lazy(
  () => import("./EstateInvestorManagement/EstateInvestorManagement"),
);

export const EstateInvestorManagementDetails = lazy(
  () =>
    import("./EstateInvestorManagement/EstateInvestorManagementDetails/EstateInvestorManagementDetails"),
);

export const EstateBankingAndFinance = lazy(
  () => import("./EstateBankingAndFinance/EstateBankingAndFinance"),
);

export const EstateManagersMortgageCard = lazy(
  () =>
    import("./EstateManagersMortgageCard/EstateManagersMortgageCard"),
);

// export const EstateHome = lazy(
//   () => import("./EstateHome/EstateHome"),
// );

export const EstateManagersSubscriberSetup = lazy(
  () =>
    import("./EstateManagersSubscriberSetup/EstateManagersSubscriberSetup"),
);

export const EstateManagersSubscriberSetupOtp = lazy(
  () =>
    import("./EstateManagersSubscriberSetup/EstateManagersSubscriberSetupOtp"),
);

export const EstateManagersSubscriberSetupCompleted = lazy(
  () =>
    import("./EstateManagersSubscriberSetup/EstateManagersSubscriberSetupCompleted/EstateManagersSubscriberSetupCompleted"),
);

export const EstateSubscriberProjects = lazy(
  () => import("./EstateSubscriberProjects/EstateSubscriberProjects"),
);

export const EstateSubscriberProjectsDetails = lazy(
  () =>
    import("./EstateSubscriberProjects/EstateSubscriberProjectsDetails/EstateSubscriberProjectsDetails"),
);

export const EstateSubscriptionDetails = lazy(
  () =>
    import("./EstateSubscriberProjects/EstateSubscriptionDetails/EstateSubscriptionDetails"),
);

export const EstateSubscriberPortfolio = lazy(
  () =>
    import("./EstateSubscriberPortfolio/EstateSubscriberPortfolio"),
);

export const EstateSubscriberPortfolioDetails = lazy(
  () =>
    import("./EstateSubscriberPortfolio/EstateSubscriberPortfolioDetails/EstateSubscriberPortfolioDetails"),
);

export const EstateSubscriberTransaction = lazy(
  () =>
    import("./EstateSubscriberTransaction/EstateSubscriberTransaction"),
);

export const EstateSubscriberTransactionDetails = lazy(
  () =>
    import("./EstateSubscriberTransaction/EstateSubscriberTransactionDetails/EstateSubscriberTransactionDetails"),
);

export const EstateSubscriberRecurrentPayment = lazy(
  () =>
    import("./EstateSubscriberRecurrentPayment/EstateSubscriberRecurrentPayment"),
);

export const EstateSubscriberRecurrentPaymentDetails = lazy(
  () =>
    import("./EstateSubscriberRecurrentPayment/EstateSubscriberRecurrentPaymentDetails/EstateSubscriberRecurrentPaymentDetails"),
);

export const DirectDebitApproval = lazy(
  () => import("./DirectDebitApproval/DirectDebitApproval"),
);

export const ApproveMandate = lazy(
  () => import("./ApproveMandate/ApproveMandate"),
);

// 
export const EstateHomeV2 = lazy(
  () => import("./EstateHomeV2/EstateHome"),
);
export const AllPropertiesPage = lazy(
  () => import("./AllProperties/AllProperties"),
);
export const PropertyDetails = lazy(
  () => import("./PropertyDetails/PropertyDetails"),
);
